/**
 * @author Kelnik
 *
 * SwiperFuct - слайдер
 */

import SliderArrows from 'components/slider-arrows';
import Swiper from 'swiper';

class SwiperFuct {
    constructor(options) {
        this.options = options;
        this.container = options.container;

        this.sliderSelector = '.j-swiper-fuct-slider';
        this.wrapperClass = 'j-swiper-fuct-wrapper';
        this.slideClass = 'j-swiper-fuct-slide';
        this.arrowsSelector = '.j-slider-arrows';

        this.prevSelector = '.j-swiper-fuct-prev';
        this.nextSelector = '.j-swiper-fuct-next';

        this.loop = false;

        this.currentIndex = 0;
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._initSwiper();
    }

    _initElements() {
        this.sliderEl = this.container.querySelector(this.sliderSelector);
        this.arrowsEl = this.container.querySelector(this.arrowsSelector);
    }

    _initSwiper() {
        this.slider = new Swiper(this.sliderEl, {
            wrapperClass    : this.wrapperClass,
            slideClass      : this.slideClass,
            slideActiveClass: 'is-active',
            speed           : 500,
            grabCursor      : true,
            loop            : this.loop,
            slidesPerView   : 'auto',
            navigation      : {
                prevEl       : this.prevSelector,
                nextEl       : this.nextSelector,
                disabledClass: 'is-disabled'
            },
            on: {
                touchStart: () => {
                    if (this.arrow) {
                        this.arrow.stopTimer();
                    }
                },
                touchEnd: () => {
                    // if (this.arrow) {
                    //     this.arrow.resumeTimer();
                    // }
                }
            }
        });
    }

    initArrows() {
        if (!this.slider) {
            return;
        }

        this.arrow = new SliderArrows({
            container: this.arrowsEl,
            timeout  : this._nextSlide.bind(this)
        });

        this.arrow.init();
    }

    _nextSlide() {
        if (this.slider.isEnd) {
            this.slider.slideTo(0);
        } else {
            this.slider.slideNext();
        }
    }

    filterSlides(val, dataName) {
        const obj = this.slider.slides;

        for (const prop in obj) {
            // eslint-disable-next-line no-prototype-builtins
            if (obj.hasOwnProperty(prop)) {
                const item = obj[prop];

                if (item.getAttribute && item.classList.contains(this.slideClass)) {
                    this._setStyleSlide(val, item, dataName);
                }
            }
        }
        this.slider.update();
    }

    _setStyleSlide(val, item, dataName) {
        let itemStyle = '';

        switch (val) {
            case 'all':
                itemStyle = 'block';
                break;
            case item.getAttribute(dataName):
                itemStyle = 'block';
                break;
            default:
                itemStyle = 'none';
        }

        item.style.display = itemStyle;
    }
}

export default SwiperFuct;
